import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import NoDataPlaceHolder from "@/components/common/NoDataPlaceHolder";
import CustomScroll from '@/components/common/CustomScroll'
import FetchJson from '@/components/common/FetchJson'
import PortalVue from 'portal-vue'

Vue.use(PortalVue);

Vue.component('NoDataPlaceHolder', NoDataPlaceHolder);
Vue.component('CustomScroll', CustomScroll);
Vue.component('FetchJson', FetchJson);

// Require the main Sass manifest file
require('./assets/sass/main.scss');

Vue.config.productionTip = false;

Vue.filter("tryToLocaleDateTime", value => {
	if (!value) return "";
	var regexp = new RegExp("(19|20)[0-9][0-9]-(0[0-9]|1[0-2])-(0[1-9]|([12][0-9]|3[01]))T([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]");
	if (!regexp.exec(value)) return value;
	const date = new Date(value);
	if (date instanceof Date && !isNaN(date)) {
		return date.toLocaleDateString();
	}
	return value;
});
Vue.filter("emptyValueToText", value => {
	if (!value) return '—';
	return value;
});
Vue.filter("sizeToKb", value => {
	let size = Number.parseInt(value, 10);
	if (isNaN(size)) return value;
	size = Math.round(size / 1024);
	return `${size} Kb`;
});
Vue.filter("emptyName", value => {
    if (!value) return '<без имени>';
    return value;
});

Vue.prototype.$publicPath = process.env.BASE_URL;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
